import React, { useContext } from 'react';
import Faq from './Faq';
import ConfigContext from '../../../contexts/ConfigContext';

const getBreweriesFaqQuestions = (siteTitle, vehicleType) => [
  {
    question: `How do food ${vehicleType}s work at breweries and taprooms?`,
    answer: `Food ${vehicleType}s partner with breweries to serve food on-site while selling directly to customers. Through ${siteTitle}, we curate and schedule a rotating lineup of food ${vehicleType}s to visit your brewery on a daily or weekly basis. Trucks arrive fully self-contained, serve food, and leave with no cleanup required, allowing breweries to offer food without operating a kitchen.`
  },
  {
    question: `Does it cost breweries anything to host food ${vehicleType}s?`,
    answer: `No. Hosting food ${vehicleType}s through ${siteTitle} is completely free for breweries and taprooms. Food ${vehicleType}s sell directly to customers, and there are no service fees, commissions, or contracts required. It's an easy way to offer food and enhance the guest experience without additional overhead.`
  },
  {
    question: `How often can food ${vehicleType}s visit my brewery?`,
    answer: `Breweries can schedule food ${vehicleType}s as frequently as they like, including daily, weekly, or rotating schedules. Many taprooms choose a consistent rotation to keep menus fresh and encourage repeat visits. Our platform adapts over time based on customer preferences and ${vehicleType} availability to keep your lineup strong.`
  },
  {
    question: `Do food ${vehicleType}s increase sales at breweries?`,
    answer: `Yes. Breweries that offer on-site food options often see increased customer dwell time and higher beverage sales. Food ${vehicleType}s encourage guests to stay longer, order more drinks, and return more frequently—without the cost or complexity of running a kitchen.`
  },
  {
    question: `What types of food ${vehicleType}s are a good fit for breweries?`,
    answer: `${siteTitle} works with a wide range of food ${vehicleType}s that pair well with beer, including tacos, burgers, pizza, Asian street food, BBQ, and vegetarian-friendly options. We focus on quality, reliability, and variety so your customers always have great food options to enjoy with their drinks.`
  },
  {
    question: `What does my brewery need to host a food ${vehicleType}?`,
    answer: `Most breweries just need a designated parking or setup area for food ${vehicleType}s. Trucks are fully self-sufficient and typically do not require access to your kitchen or staff. If power, space, or permitting questions come up, our team helps coordinate details to ensure a smooth setup.`
  }
];

function BreweriesFaq() {
  const { site_title, vehicle_type } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  const questions = getBreweriesFaqQuestions(site_title, vehicleType);

  return (
    <Faq questions={questions} />
  );
}

export default BreweriesFaq;
